module.exports = __webpack_public_path__ + "img/QFAD-logo-1793698374569.png";